import React from 'react';

import { useSnackbar } from 'notistack';

import { ContentCopy } from '@mui/icons-material';
import { IconButton, Link, Typography } from '@mui/material';

interface MetaInfoItemProps {
  label: string;
  value: string;
  url?: string;
}

function MetaInfoItem({ label, value, url }: MetaInfoItemProps) {
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyClick = (id: string) => {
    navigator.clipboard.writeText(id);
    enqueueSnackbar(`Copied to clipboard`, { variant: 'success' });
  };

  return (
    <Typography>
      <Typography component="span" fontWeight="bold">
        {label}:
      </Typography>
      &nbsp;
      {url ? (
        <Link href={url} target="_blank" rel="noopener">
          {value}
        </Link>
      ) : (
        value
      )}
      <IconButton title={`Copy ${label}`} onClick={() => handleCopyClick(value)}>
        <ContentCopy fontSize="small" />
      </IconButton>
    </Typography>
  );
}

export default MetaInfoItem;
